import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';

class CreditCardElements extends Component {

  constructor() {
    super();

    this.state = {
      cardBrand: ''
    };
  }

  onCardNumberChange = ({ error, brand }) => {
    const {
      setCardError,
      hideServerError
    } = this.props;
    this.setState({
      cardBrand: brand
    });
    setCardError(error);
    hideServerError && hideServerError();
  };

  onCardChange = ({ error }) => {
    const {
      setCardError,
      hideServerError
    } = this.props;
    setCardError(error);
    hideServerError && hideServerError();
  }

  render() {
    const baseStyle = {
      base: {
        fontFamily: 'Open Sans, sans-serif',
        fontSize: '16px',
        color: '#5e5e5e',
        fontWeight: '400',
        fontSmoothing: 'antialiased'
      }
    };

    const baseClasses = {
      focus: 'is-focused',
      empty: 'is-empty',
    };

    const baseProps = {
      className: 'field',
      disabled: this.props.disabled,
      hidePostalCode: true,
      style: baseStyle,
      classes: baseClasses
    };

    return (
      <div id='credit-card-elements'>
        <label>
          <CardNumberElement
            {...baseProps}
            onChange={this.onCardNumberChange}
            placeholder={this.props.cardPlaceholder}
          />
          <span id='card_number' className={this.state.cardBrand}>
            <span>Credit card number</span>
          </span>
          <span className='visa'></span>
          <span className='mastercard'></span>
          <span className='amex'></span>
        </label>
        <label className='quarter-width left'>
          <CardExpiryElement
            {...baseProps}
            onChange={this.onCardChange}
            placeholder={this.props.expirationPlaceholder}
          />
          <span><span>Expiration</span></span>
        </label>
        <label className='quarter-width right'>
          <CardCvcElement
            {...baseProps}
            onChange={this.onCardChange}
            placeholder={this.props.cardCvcPlaceholder}
          />
          <span><span>Security Code</span></span>
        </label>
      </div>
    );
  }
}

CreditCardElements.propTypes = {
  disabled: PropTypes.bool,
  cardPlaceholder: PropTypes.string,
  expirationPlaceholder: PropTypes.string,
  cardCvcPlaceholder: PropTypes.string,
  setCardError: PropTypes.func.isRequired,
  hideServerError: PropTypes.func.isRequired
};

CreditCardElements.defaultProps = {
  disabled: false,
  cardPlaceholder: '',
  expirationPlaceholder: '',
  cardCvcPlaceholder: ''
};

export default CreditCardElements;



// WEBPACK FOOTER //
// ./src/containers/components/credit-card-elements.js